import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Label } from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

const ClickToCallContent = ({ content, onChange }) => {
  const handleInstanceIdChange = instanceId => {
    onChange({ ...content, instanceId });
  };

  const handleContactFlowIdChange = contactFlowId => {
    onChange({ ...content, contactFlowId });
  };

  const handleSourcePhoneNumberChange = sourcePhoneNumber => {
    onChange({ ...content, sourcePhoneNumber });
  };

  const handleDestinationPhoneNumberChange = destinationPhoneNumber => {
    onChange({ ...content, destinationPhoneNumber });
  };

  const handleRegionChange = region => {
    onChange({ ...content, region });
  };

  return (
    <Flex col fat="true" gap="sm">
      <Flex col fat>
        <Label>Instance ID*</Label>
        <TemplatingTextInput
          aria-label="Instance ID"
          placeholder="Instance ID"
          value={content.instanceId}
          onChange={handleInstanceIdChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Contact Flow ID*</Label>
        <TemplatingTextInput
          aria-label="Contact Flow ID"
          placeholder="Contact Flow ID"
          value={content.contactFlowId}
          onChange={handleContactFlowIdChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Source Phone Number*</Label>
        <TemplatingTextInput
          aria-label="Source Phone Number"
          placeholder="Source Phone Number"
          value={content.sourcePhoneNumber}
          onChange={handleSourcePhoneNumberChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Destination Phone Number*</Label>
        <TemplatingTextInput
          aria-label="Destination Phone Number"
          placeholder="Destination Phone Number"
          value={content.destinationPhoneNumber}
          onChange={handleDestinationPhoneNumberChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Region</Label>
        <TemplatingTextInput
          aria-label="Region"
          placeholder="Region (optional)"
          value={content.region}
          onChange={handleRegionChange}
        />
      </Flex>
    </Flex>
  );
};

ClickToCallContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    instanceId: PropTypes.string.isRequired,
    contactFlowId: PropTypes.string.isRequired,
    sourcePhoneNumber: PropTypes.string.isRequired,
    destinationPhoneNumber: PropTypes.string.isRequired,
    region: PropTypes.string,
    attributes: PropTypes.array
  }).isRequired
};

export default ClickToCallContent;
